import React, { JSX, useState } from 'react';
import {
  AdvancedMarker,
  InfoWindow,
  Pin,
  useAdvancedMarkerRef
} from '@vis.gl/react-google-maps';
import { RetrievedPartner } from '@/lib/sanity/responseTypes';

interface PartnerMapMarkerProps {
  partner: RetrievedPartner;
  position: { lat: number, lng: number };
  color: string;
}

export const PartnerMapMarker = (props: PartnerMapMarkerProps) => {
  const [showInfo, setShowInfo] = useState<boolean>(false)
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        onClick={() => setShowInfo(true)}
        position={props.position}
      >
        <Pin
          background={props.partner.invento ? "#231556" : "#FF6A1B"}
          glyphColor={"white"}
          borderColor={"white"}
        />
        {showInfo && (
          <InfoWindow
            anchor={marker}
            maxWidth={300}
            onCloseClick={() => setShowInfo(false)}
            headerContent={<div className="font-semibold">{props.partner.name}</div>}
          >
            <>{props.partner.name}</><br />
            <>{props.partner.addressLine1}</><br />
            {props.partner.addressLine2 && props.partner.addressLine2.length > 0 ?
              (<>{props.partner.addressLine2}<br /></>) : null}
            <>{props.partner.zip} {props.partner.town}<br /></>
            <>{props.partner.country}</>
          </InfoWindow>
        )}
      </AdvancedMarker>
    </>
  )
};

export default PartnerMapMarker;
